<nav class="side-nav" aria-label="Main navigation">
  <div class="side-nav__brand">
    <span class="side-nav__brand-text">{{ brandName() }}</span>
  </div>
  <ul class="side-nav__list">
    @for (item of navItems(); track item.labelKey) {
      <li class="side-nav__item">
        @switch (item.type) {
          @case ("messages") {
            <a
              href="#"
              class="side-nav__link"
              [class.side-nav__link--active]="isMessagesActive"
              (click)="onMessagesClick(); $event.preventDefault()"
              [attr.aria-label]="areNewMessages ? ('accessibility.goMessagePageNewMessage' | translate) : ('accessibility.goMessagePage' | translate)">
              <img
                [ngSrc]="item.icon"
                [alt]="item.labelKey | translate"
                width="22"
                height="22"
                class="side-nav__icon"
                [class.side-nav__icon--invert-white]="item.labelKey === 'mainPage.videovisits'"/>
              <span class="side-nav__text">{{ item.labelKey | translate | uppercase }}</span>
              @if (unreadMessagesCount > 0) {
                <span class="side-nav__badge"
                      aria-hidden="true">{{ unreadMessagesCount > 99 ? '99+' : unreadMessagesCount }}</span>
              }
            </a>
          }
          @case ("button") {
            <button
              type="button"
              class="side-nav__link side-nav__link--button"
              (click)="onLogout()">
              <img
                [ngSrc]="item.icon"
                [alt]="item.labelKey | translate"
                width="22"
                height="22"
                class="side-nav__icon"/>
              <span class="side-nav__text">{{ item.labelKey | translate | uppercase }}</span>
            </button>
          }
          @default {
            <a
              [routerLink]="item.routerLink"
              routerLinkActive="side-nav__link--active"
              [routerLinkActiveOptions]="{ exact: item.routerLinkExact ?? false }"
              class="side-nav__link">
              <img
                [ngSrc]="item.icon"
                [alt]="item.labelKey | translate"
                width="22"
                height="22"
                class="side-nav__icon"/>
              <span class="side-nav__text">{{ item.labelKey | translate | uppercase }}</span>
              @if (item.labelKey === "sideBottomNav.videovisits" && videoVisitsCount > 0) {
                <span class="side-nav__badge"
                      aria-hidden="true">{{ videoVisitsCount > 99 ? '99+' : videoVisitsCount }}</span>
              }
            </a>
          }
        }
      </li>
    }
  </ul>
  <div class="side-nav__footer">
    <app-action-button
      routerLink="/contact"
      variant="primary"
      size="compact">
      {{ 'sideBottomNav.techFeedback' | translate | uppercase }}
    </app-action-button>
  </div>
</nav>
